<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading_d">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="masterInfoAssets" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab3" aria-selected="false" @click="onClickTab('3')">
              {{ $t("content.editimg") }}
            </button>
          </li>
        </ul>

        <div id="bmTabContent" class="tab-content">
          <div id="tab3" class="tab-pane fade" role="tabpanel" aria-labelledby="tab3-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.editimg") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.shop_name") }}</label>
                    <select v-model="search_shopi" class="form-select" :disabled="shopList.length === 0">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(item, index) in shopList" :value="item.uid" :key="index">
                        {{ item.nameTh }}
                      </option>
                    </select>
                  </div>


                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input v-model="tk_searchi" id="ticketno" type="text" :disabled="search_shopi === ''" />
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="getHistoryByRefnumber" :disabled="search_shopi === '' || tk_searchi === ''">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ $t('buttons.sear') }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelIBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ $t('buttons.canc') }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.amnticketold") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.migraref") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>
                            {{ $t("content.actpawn3") }} /
                            {{ $t("content.actpawn4") }}
                          </th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.assessor") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhistory" :key="index"
                          :class="row.status !== 'TERMINATE' ? '' : 'bg-working'">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.cusName }}
                            </span>
                            <span v-else>
                              {{ row.tkCusName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.stockNumber }}</td>
                          <td class="text-sm font-weight-normal text-center">{{ row.migrateRefNumber }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ทำแทน)
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ออนไลน์)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ออนไลน์)
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.diffValue) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.payOrReceive) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.managerName }}</td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ checkProcess(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.editimg')"
                              @click="openGallery(row)">
                              <i class=" material-icons material-symbols-outlined">photo_library</i>
                            </material-button>
                            <material-button data-bs-toggle="modal" data-bs-target="#attachmentsModal" v-show="false"
                              id="attachmenDialog">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhistory.length === 0">
                          <td colspan="16" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header" style="background-color: white;">
                          <td class="text-lg font-weight-bold text-end text-center" colspan="8">
                            <span v-if="listhistory.length > 0">
                              <b>{{ $t("content.gtotal") }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalWeight) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberString(totalQuantity) }}</b>
                            </span>
                          </td>

                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold" colspan="4"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <!-- Delete File Dialog -->
          <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="unseizeModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 700px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ $t("content.insertimg") }} : {{ images.length }}
                  </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeattach">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <pre></pre>
                    <div class="grid-containerP" v-if="images.length">
                      <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                        <td>
                          <div class="wrapper">
                            <figure width="100px" height="100px">
                              <img :src="item.src" class="img img-fluid" />
                            </figure>
                            <button type="button" class="btn myLayer" style="color: red;" :title="t('buttons.dele')"
                              @click="removeImage(item, index)">
                              <i i class="material-icons">close</i>
                            </button>
                          </div>
                        </td>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>


          <!-- Workcase Info Dialog -->
          <div id="workcaseInfoModal" class="modal fade" tabindex="-1" aria-labelledby="workcaseInfoModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 1000px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Workcase Info
                  </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeWorkcaseInfo">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <Textarea v-model="workcaseInfo" class="w-100" autoResize variant="filled" disabled />
                  </fieldset>
                </div>
              </div>
            </div>
          </div>




        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { inject, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import InputNumber from 'primevue/inputnumber';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import Textarea from 'primevue/textarea';
import moment from 'moment'
import ExampleFive from "@/examples/ExampleOne";
import ProgressSpinner from 'primevue/progressspinner';
import nofinger from "@/assets/img/noimg.png"
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import * as st from "@/config/setting.js";
import axios from "axios";

import { useWorkCaseStore } from '@/stores/workcase'
import { useCategoryStore } from '@/stores/category'
import { useDocumentStore } from '@/stores/document'

const { t } = useI18n();
const swal = inject("$swal");

const storew = useWorkCaseStore()
const storecat = useCategoryStore()
const storedoc = useDocumentStore()

const shopList = ref([]);
const search_shopi = ref("");
const tk_searchi = ref('');

const listhistory = ref([]);
const listprint = ref([]);

const workcaseDetail_i = ref(null);
const images = ref([])
const images_l = ref([])
const loading_d = ref(false);

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const totalQuantity = ref(0);
const totalPawnValue = ref(0);
const totalWeight = ref(0);
const totalInterest = ref(0);

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const onClickHandler = (page) => {
  updatePagination()
};

const infoshop = async (val) => {
  shopList.value = []
  if (localStorage.getItem("shoplist") !== null) {
    shopList.value = JSON.parse(localStorage.getItem("shoplist"));
    // console.log("shopList dash : ", shopList.value);
  }
}

infoshop()

const loadDataPrintApi = async () => {
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  const response = await storecat.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
      }
    }
  }
}

loadDataPrintApi();


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined && num !== '') {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm')
  }
}



async function onClickTab(val) {
  if (val === '3') {
    await setthirddTab()
  }
}

async function cancelIBtn() {
  search_shopi.value = ''
  tk_searchi.value = ''
  listhistory.value = []
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  totalRows_s.value = ''
  currentPage.value = 1
  workcaseDetail_i.value = null
}




function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  } else if (str === 'REVIEW_COLLATERAL') {
    side = 'ขอดูทรัพย์'
  } else if (str === 'PAYMENT') {
    side = 'การชำระ'
  }
  return side
}

function checkProcess(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'เสร็จสิ้น'
  } else if (str === 'ACTIVE') {
    side = 'กำลังดำเนินการ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'TERMINATE') {
    side = 'ยกเลิก'
  } else if (str === 'BREAKING') {
    side = 'ของหลุด'
  } else {
    side = str
  }
  return side
}


async function getWorkCaseImgInfo(item) {
  workcaseDetail_i.value = null
  images_l.value = []
  images.value = []

  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: search_shopi.value,
    uid: item.uid,
  };
  const payload = data;
  // console.log('wc p : ' + JSON.stringify(payload));
  const response = await storew.workCaseinfoAdminFetch(payload);
  // console.log('wc r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail_i.value = response.data.data
        images_l.value = workcaseDetail_i.value.ticket.images
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function openGallery(item) {
  await getWorkCaseImgInfo(item)
  
  if (images_l.value.length > 0) {
    loading_d.value = true
    images.value = []
    
    // 1. กรองเอาเฉพาะรายการไฟล์ที่มี imageUid จริงๆ (ไม่เป็น "0") มารวมกลุ่มไว้
    const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

    if (validFiles.length > 0) {
      // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload
      const requests = validFiles.map((fileItem) => {
        const payload = {
          groupUid: key.groupUid || "", // เปลี่ยนให้ตรงกับชื่อตัวแปรดักกรุ๊ป/ร้านค้าของหน้านี้
          shopUid: search_shopi?.value || "",  
          uid: String(fileItem.imageUid)       // รหัสไอดีของไฟล์แนบ
        };
        // เรียกใช้ผ่าน Store ส่วนกลางที่แก้เป็น POST + Blob เรียบร้อยแล้ว [INDEX]
        return storedoc.getFileFetch(payload); // 💡 เช็คชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ (เช่น storedoc หรือ stored)
      });

      try {
        // 🟢 3. ยิงดาวน์โหลดทุกไฟล์พร้อมกันแบบขนานด้วย Promise.all [INDEX]
        const allResults = await Promise.all(requests);
        
        if (allResults) {
          for (let i = 0; i < allResults.length; i++) {
            if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
              const rawData = allResults[i].data;
              const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
              
              if (isBlob) {
                // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
                const textHead = await rawData.slice(0, 4).text();
                let cleanBlob;
                let fileType;

                if (textHead === "%PDF") {
                  cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                  fileType = 'application/pdf';
                } else if (textHead.startsWith("PK")) {
                  cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                } else {
                  // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง ครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน
                  cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                  fileType = 'image/jpeg';
                }

                const dataUrl = URL.createObjectURL(cleanBlob);
                const originalItem = validFiles[i];

                images.value.push({
                  src: dataUrl,
                  thumbnailImageSrc: dataUrl,
                  alt: '',
                  title: fileType, 
                  filename: 'attachment_' + originalItem.imageUid, 
                  uid: originalItem.uid,
                  imageUid: originalItem.imageUid,
                  rawBlob: cleanBlob 
                });
              }
            }
          }
        }
      } catch (e) {
        console.error("Error in Promise.all openGallery:", e);
        loading_d.value = false;
        swal('เกิดข้อผิดพลาด', 'ไม่สามารถดึงไฟล์จากระบบได้', 'error');
        return;
      }
    }

    // 🟢 4. แยกเส้นทางการพรีวิวและเปิดใช้งานป๊อปอัปตามประเภทไฟล์จริง (ดึงตัวแรกมาเช็คทิศทาง)
    if (images.value.length > 0) {
      const targetFile = images.value[0]; 
      const fileType = targetFile.title || "";
      const fileSrc = targetFile.src || "";

      if (fileType === 'application/pdf') {
        // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที
        loading_d.value = false;
        window.open(fileSrc, '_blank');

      } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
        // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมชื่อที่สั้นและอ่านง่าย
        loading_d.value = false;
        let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
        let fileNameDownload = `excel_${today}.xlsx`;
        
        const link = document.createElement('a');
        link.href = fileSrc;
        link.setAttribute('download', fileNameDownload);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } else {
        // 🖼️ กรณีเป็นรูปภาพปกติ -> เปิดกล่องป๊อปอัป Modal หน้านี้ตามลอจิกเดิมของคุณ
        loading_d.value = false;
        document.getElementById("attachmenDialog").click(); // ไอดีเดิมสะกดตามโค้ดในรูปคุณ
      }

    } else {
      loading_d.value = false;
      swal('Record not found', "", "error");
    }
  } else {
    loading_d.value = false;
    swal('Record not found', "", "error");
  }
}


async function removeImage(item, index) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        deleteFile(item.uid, index);
      }
    }
  });
}

async function deleteFile(id, index) {
  let data = "";
  data = {
    uid: id,
    shopUid: search_shopi.value,
  };
  const payload = data;
  // console.log("delf p : " + JSON.stringify(payload));
  const response = await storedoc.deleteTkImgFetch(payload);
  // console.log("delf r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        images.value.splice(index, 1);
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function getHistoryByRefnumber() {
  listhistory.value = []
  let data = "";
  data = {
    index: 0,
    size: perPage.value,
    cusUid: '',
    groupUid: key.groupUid,
    refNumber: tk_searchi.value.trim(),
    shopUid: search_shopi.value,
    fromDate: '',
    toDate: '',
    type: '',
    serialNumber: '',
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: '',
    active: 'NONE',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
    postpone: 'NONE',
  };
  const payload = data;
  // console.log('wcs p : ' + JSON.stringify(payload));
  const response = await storew.workCaseHistoryFetch(payload);
  // console.log('wcs r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function updatePagination() {
  listhistory.value = []
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: '',
    groupUid: key.groupUid,
    refNumber: tk_searchi.value.trim(),
    shopUid: search_shopi.value,
    fromDate: '',
    toDate: '',
    type: '',
    serialNumber: '',
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: '',
    active: 'NONE',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
    postpone: 'NONE',

  };
  const payload = data;
  const response = await storew.workCaseHistoryFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


async function setthirddTab() {

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.add('show', 'active')
  }
}

onMounted(() => {

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.add('show', 'active')
  }
});
</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}
</style>
